import { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import HeadlessTippy from '@tippyjs/react/headless';

import styles from './Profile.module.scss';
import Image from '~/components/Img';
import Button from '~/components/Button';
import { BanIcon, EllipsisHorizontalIcon, FlagIcon, LinkIcon, ShareIcon, UserRegularIcon } from '~/components/Icons';
import ShareAction from '~/components/ShareAction';
import VideoPreview from '~/components/VideoPreview';
import Popper from '~/components/Popper';
import { ModalContext } from '~/components/ModalProvider';
import { mockVideos } from '~/configs/videos';

const cx = classNames.bind(styles);

function Profile() {
    const location = useLocation();

    console.log("location.state", location.state)

    const data = location.state;

    const [videos, setVideos] = useState([]);
    const context = useContext(ModalContext);

    useEffect(() => {
        if (data.nickname === 'SunMinh🤖') {
            // Mock data
            const result = [...mockVideos];


            setVideos(result);
        } else {
            fetch(`https://tiktok.fullstack.edu.vn/api/users/@${data.nickname}`)
                .then((response) => response.json())
                .then((json) => setVideos(json.data.videos));
        }
    }, [data.nickname]);

    return (
        <div className={cx('profile-wrapper')}>
            <div className={cx('info-container')}>
                <div className={cx('info')}>
                    <div className={cx('basic')}>
                        <Image className={cx('avatar')} src={data.avatar} alt={data.avatar} />
                        <div className={cx('text')}>
                            <div className={cx('username')}>{data.nickname}</div>
                            <div className={cx('name')}>{data.full_name || `${data.first_name} ${data.last_name}`}</div>
                            <Button color primary style={{ minWidth: '208px' }} onClick={context.handleShowModal}>
                                关注
                            </Button>
                        </div>
                    </div>

                    <div className={cx('counts')}>
                        <div className={cx('following')}>
                            <strong>{data.followings_count}</strong> 关注中
                        </div>
                        <div className={cx('followers')}>
                            <strong>{data.followers_count}</strong> 粉丝
                        </div>
                        <div className={cx('likes')}>
                            <strong>{data.likes_count}</strong> 获赞
                        </div>
                    </div>

                    <div className={cx('bio')}>{data.bio ? data.bio : '暂无简介'}</div>

                    <a href={data.website_url} target="blank">
                        {data.website_url && (
                            <div className={cx('website')}>
                                <LinkIcon className={cx('link-icon')} />
                                {data.website_url}
                            </div>
                        )}
                    </a>
                </div>
                <div className={cx('side-btns')}>
                    <div className={cx('share-btn')}>
                        <ShareAction offset={[-100, 10]}>
                            <div>
                                <ShareIcon />
                            </div>
                        </ShareAction>
                    </div>

                    <HeadlessTippy
                        interactive
                        hideOnClick="false"
                        placement="bottom-end"
                        offset={[0, 10]}
                        delay={[0, 700]}
                        zIndex="99"
                        render={(attrs) => (
                            <div tabIndex="-1" {...attrs}>
                                <Popper className={cx('more-tab')}>
                                    <div className={cx('action-report')}>
                                        <p>
                                            <FlagIcon height="16" /> 举报
                                        </p>
                                    </div>
                                    <div className={cx('action-block')}>
                                        <p>
                                            <BanIcon /> 拉黑
                                        </p>
                                    </div>
                                </Popper>
                            </div>
                        )}
                    >
                        <div>
                            <EllipsisHorizontalIcon />
                        </div>
                    </HeadlessTippy>
                </div>
            </div>

            <div className={cx('video-container')}>
                <div className={cx('tabs')}>
                    <p className={cx('video-tab')}>作品</p>
                    <p className={cx('liked-tab')}>点赞</p>
                    <div className={cx('underline')}></div>
                </div>

                {videos.length > 0 && (
                    <div className={cx('videos')}>
                        {videos.map((video, index) => {
                            return <VideoPreview data={video} key={index} />;
                        })}
                    </div>
                )}

                {videos.length === 0 && (
                    <div className={cx('no-content')}>
                        <div>
                            <UserRegularIcon />
                            <p className={cx('title')}>暂无内容</p>
                            <p className={cx('description')}>该用户尚未发布视频</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Profile;
